import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer } from 'antd';
import SearchBar from '../common/Searchbar';
import EvaluateChapterList from './EvaluateChapterList';
import { setEvaluateOpen } from '../../features/Evaluate/EvaluateOpenSlice';
import { RootState } from '../../store';

interface EvaluateModalProps {
    resources: any;
    keys: any;
}

const EvaluateModal: React.FC<EvaluateModalProps> = ({ resources, keys }) => {
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [selectedButton, setSelectedButton] = useState<string>(
        keys.length > 0 ? keys[0] : ''
    );
    const evaluatePdfPlayerData = useSelector(
        (state: RootState) => state.evaluatePdfPlayer
    );

    const [filteredChapters, setFilteredChapters] = useState<any>([]);

    const dispatch = useDispatch();
    const isOpen = useSelector((state: RootState) => state.EvaluateOpen.isOpen);

    // Close the drawer
    const handleEvaluateClose = () => {
        dispatch(setEvaluateOpen(false));
    };

    // Handle button click to set selected button and filter chapters
    const handleButtonClick = async (buttonName: string) => {
        setSelectedButton(buttonName);
        // Find the object in 'resources' based on the button clicked
        const resource = resources[buttonName];

        if (!resource) {
            console.error(`No resources found for ${buttonName}`);
            setFilteredChapters([]);
            return;
        }

        // Filter resources based on the search term
        const filtered = resource.filter((item: any) =>
            item.title.toLowerCase().includes(searchTerm.toLowerCase())
        );

        setFilteredChapters(filtered);
    };

    useEffect(() => {
        if (selectedButton) {
            handleButtonClick(selectedButton);
        }
    }, [searchTerm]);

    return (
        <>
            {!evaluatePdfPlayerData.isOpen && (
                <Drawer
                    title="Evaluate"
                    placement="right"
                    closable
                    onClose={handleEvaluateClose}
                    open={isOpen}
                    width="60rem"
                    destroyOnClose
                >
                    <div className=" absolute top-[0.5rem] left-[30rem] -right-[15rem] w-auto">
                        <SearchBar
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                    </div>

                    {/* Row of buttons based on resources */}
                    <div className="flex justify-start space-x-4 -mt-4">
                        {keys.map((key: any) => (
                            <button
                                key={key}
                                onClick={() => handleButtonClick(key)}
                                className={`px-4 py-2 border-b-2 transition-all duration-300 ${
                                    selectedButton === key
                                        ? 'text-blue-500 border-blue-500'
                                        : 'text-gray-700 border-transparent'
                                }`}
                            >
                                {key}
                            </button>
                        ))}
                    </div>

                    <hr className="border-solid border-gray-300 mt-4 -mx-12" />

                    <div className="overflow-y-auto custom-scrollbar">
                        <EvaluateChapterList chapters={filteredChapters} />
                    </div>
                </Drawer>
            )}
        </>
    );
};

export default EvaluateModal;
